export default "__VITE_ASSET__ae908ee5__"